import React from "react";
import { Link } from "react-router-dom";
import dwlLogo from "../images/dwl_logo_login.png";

const Header = ({ handlelogout, isAdmin }) => {
  return (
    <header className={isAdmin ? "admin-header" : "header"}>
      <div className="container">
        <div className="logos flex v-center f-wrap">
          <div className="logo">
            <img
              src={dwlLogo}
              alt="Dwellworks logo"
              onClick={() => {
                window.location.href = "/";
              }}
            />
            {isAdmin ? (
              <>
                <Link to="/user" className="menu-item">
                  User
                </Link>
                <Link to="/userrequest" className="menu-item">
                  User Request
                </Link>
              </>
            ) : (
              ""
            )}
          </div>
          <div className="logo end">
            <div className="logout" onClick={handlelogout}>
              Logout
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
